export const TWENTY_FIVE_MEGABYTES = 1024 * 1024 * 25
export const VA_PUBLIC_SITE = "https://visual-alpha.com"
export const DECIMAL_DIGITS_LIMIT = 12

const constants = {
  VA_PUBLIC_SITE
}

export default constants
